module.exports = __webpack_public_path__ + "static/img/stoneAndChalkColor.7f95cb0e.png";